export default "__VITE_ASSET__ecf8ce82__"